<template>
    <!-- Blog Section -->
	<section class="section blog-section">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-lg-6 text-center wow fadeInUp" data-wow-delay="0.2s">
					<div class="section-header text-center">
						<h2 class="mb-1">Checkout our Recent <span class="text-linear-primary">Blogs</span></h2>
						<p class="sub-title">Each listing is designed to be clear and concise, providing customers</p>
					</div>
				</div>
			</div>
			<div class="blog-slider owl-carousel nav-center nav-center">
                <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
                    <Slide v-for="item in homeBlog" :key="item.id">
                        <div class="blog-item wow fadeInUp" data-wow-delay="0.2s">
                            <div class="blog-img">
                                <router-link to="/blogs/blog-details">
                                    <img :src="require(`@/assets/img/blogs/${item.Image}`)" class="img-fluid" alt="img">
                                </router-link>
                            </div>
                            <div class="blog-content text-start">
                                <p class="fs-14 fw-meium text-gray-9 d-inline-flex align-items-center mb-2">Admin<i
                                        class="ti ti-circle-filled fs-6 mx-1"></i>{{item.Date}}</p>
                                <h6 class="text-truncate mb-2"><router-link to="/blogs/blog-details">{{item.Title}}</router-link>
                                </h6>
                                <p class="two-line-ellipsis mb-3">{{item.Content}}</p>
                                <div class="d-flex align-items-center flex-wrap">
                                    <span class="badge badge-info-transparent me-2">{{item.BadgeOne}}</span>
                                    <span class="badge badge-dark-transparent">{{item.BadgeTwo}}</span>
                                </div>
                            </div>
                        </div>
                    </Slide>
                    <template #addons>
                        <Navigation />
                    </template>
                </Carousel>
			</div>
			<div class="text-center mt-5 wow fadeInUp" data-wow-delay="0.2s">
				<router-link to="/blogs/blog-list" class="btn btn-dark">View All<i class="ti ti-arrow-right ms-2"></i></router-link>
			</div>
		</div>
	</section>
	<!-- / Blog Section -->

	<!-- Business Section -->
	<section class="section business-section bg-black">
		<div class="container">
			<div class="row align-items-center bg-01">
				<div class="col-md-6 wow fadeInUp" data-wow-delay="0.2s">
					<div class="section-header mb-md-0 mb-4">
						<h2 class="text-white display-4">Add Services & Grow your <span
								class="text-linear-primary">business with us</span></h2>
						<p class="text-light">A versatile platform that connects you with local professionals across
							various categories, from home services like plumbing and electrical work to personal
							services like photography and tutoring.</p>
						<a href="javascript:void(0);" class="btn btn-linear-primary"><i
								class="ti ti-user-filled me-2"></i>Join Us</a>
					</div>
				</div>
				<div class="col-md-6 text-md-end wow fadeInUp" data-wow-delay="0.2s">
					<div class="business-img">
						<img src="@/assets/img/business.jpg" class="img-fluid" alt="img">
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- /Business Section -->
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import homeBlog from '@/assets/json/frontend/home-blog.json'
import "vue3-carousel/dist/carousel.css";

export default {
    data() {
        return {
            homeBlog: homeBlog,
            settings: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            breakpoints: {
                575: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                767: {
                    itemsToShow: 1,
                    snapAlign: "center",
                },
                991: {
                    itemsToShow: 3,
                    snapAlign: "center",
                },
                1024: {
                    itemsToShow: 4,
                    snapAlign: "start",
                },
            },
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
        Pagination,
    },
}
</script>